import React, { useState, useRef, useEffect } from 'react';
import { useLocalStorage } from '../../../../services/LocalStorageProvider';

const VideoTaskDemonstration: React.FC<{videoSrc: string}> = ({
  videoSrc
}) => {
  const ref = useRef<HTMLVideoElement>(null);
  const { storage, updateStorage } = useLocalStorage();
  const isRecording = storage?.isRecording || false;
  const [hasBeenPlayed, setHasBeenPlayed] = useState(() => false);

  const stopPlaying = () => {
    if (ref.current) {
      ref.current.pause();
      ref.current.currentTime = 0;
    }
  };

  useEffect(() => {
    updateStorage({ disableRecording: true });

    return () => {
      stopPlaying();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isRecording) {
      stopPlaying();
    }
  }, [isRecording]);

  useEffect(() => {
    if (hasBeenPlayed && storage?.disableRecording) {
      updateStorage({ disableRecording: false });
    }
  }, [hasBeenPlayed, storage?.disableRecording, updateStorage]);

  return (

    <div className={`video-task-demonstration ${isRecording ? 'disabled' : ''}`}>
      <video
        ref={ref}
        src={videoSrc}
        controls
        onEnded={() => setHasBeenPlayed(true)}
        style={{ width: '100%', maxWidth: 480 }}
        data-testid="video-task-demo"
      />
    </div>
  );
};

export default VideoTaskDemonstration;
